import Footer from '@/components/Footer.vue'
import TopMenu from '@/components/common/top-menu/index.vue'
import Banner from '@/components/common/Banner.vue'
import BehaviorValidation from '@/components/behavior-validation/index.vue'
import BasicTop from '@/apps/assessment/components/basic-top/index.vue'
import SecondTop from '@/apps/assessment/components/second-top/index.vue'
import { throttle, debounce } from 'throttle-debounce'
import trackMixin from '@/common/trackMixin.js'

export default {
  name: 'BasicLayout',
  mixins: [trackMixin],
  props: {
    msg: String,
    noPick: Boolean,
    showSubject: {
      default() {
        return true
      },
      type: Boolean
    },
    nomenu: {
      default() {
        return false
      },
      type: Boolean
    },
    breadcrumb: {
      default() {
        return true
      },
      type: Boolean
    },
    showBanner: {
      default() {
        return false
      },
      type: Boolean
    },
    showSecondMenu: {
      default() {
        return true
      },
      type: Boolean
    },
    isClazz: {
      default() {
        return false
      },
      type: Boolean
    }
  },
  mounted() {
    this.titleFixed = false
    try {
      window.addEventListener('scroll', throttle(20, this.handleScroll), true)
    } catch (e) {
      console.log(e)
    }
  },
  data() {
    return {
      titleFixed: false,
      list: [],
      haveScrollBar: false
    }
  },
  watch: {
    user: {
      handler(val, old) {
        if (val && val.name) {
        }
      },
      deep: true
    }
  },
  components: { TopMenu, Footer, Banner, BehaviorValidation, BasicTop, SecondTop },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  methods: {
    subject(val) {
      // console.log(val)
    },
    target() {
      return document.getElementById('app')
    },
    handleScroll() {
      try {
        let offsetTop =
          this.$refs &&
          this.$refs.question_bus &&
          this.$refs.question_bus.getBoundingClientRect().top
        let element = document.getElementById('app')
        let offsetWidth = element.offsetWidth
        let clientwidth = element.clientWidth
        this.titleFixed = offsetTop < -78
        if (offsetWidth - clientwidth > 0 && this.titleFixed) {
          this.haveScrollBar = true
        } else {
          this.haveScrollBar = false
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
